<template>
  <div class="diff-panel">
    <div v-for="l in lines" :key="l.num"
      :class="{added: l.added, removed: l.removed}">{{l.value}}</div>
  </div>
</template>

<script>
import {diffLines} from 'diff'

function j(x) {
  if ( x == null ) return ''
  return JSON.stringify(x, null, ' ')
}

export default {
  props: {
    payload: {}
  },
  computed: {
    lines() {
      if ( this.payload == null ) return []
      let before = j(this.payload.before),
          after = j(this.payload.after),
          result = diffLines(before, after)

      return result
    }
  }
}
</script>

<style>
.diff-panel > div {
  font-family: 'Courier New', Courier, monospace;
  white-space: pre;
  margin-left: 20px;
  position: relative;
}

.diff-panel .added {
  color: green
}

.diff-panel .added:before {
  content: '+';
  position: absolute;
  left: -20px;
}

.diff-panel .removed {
  color: red
}

.diff-panel .removed:before {
  content: '-';
  position: absolute;
  left: -20px;
}

</style>